import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("admin@allcrane.com");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await login(email, password);
            toast.success("Welcome to All Crane Command Centre");
            nav("/", { replace: true });
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Login failed");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div
            className="min-h-screen login-bg flex items-center justify-center px-6"
            data-testid="login-page"
        >
            <div className="w-full max-w-md">
                <div className="text-center mb-10">
                    <div className="inline-flex items-center gap-3">
                        <img
                            src="/all-crane-logo-sm.png"
                            alt="All Crane Sales"
                            className="h-12 w-auto"
                            style={{ filter: "brightness(0) invert(1)" }}
                            data-testid="login-brand-logo"
                        />
                        <div className="text-left">
                            <div
                                className="text-white text-xl font-medium tracking-tight"
                                style={{ fontFamily: "Fraunces, serif" }}
                            >
                                All Crane
                            </div>
                            <div className="text-[10px] uppercase tracking-[0.24em] text-zinc-400">
                                Command Centre
                            </div>
                        </div>
                    </div>
                </div>

                <div className="acc-card p-8" style={{ background: "#ffffff" }}>
                    <div className="mb-6">
                        <h1
                            className="text-2xl font-medium tracking-tight font-display"
                            data-testid="login-heading"
                        >
                            Sign in
                        </h1>
                        <p className="text-sm text-zinc-500 mt-1">
                            Owner, accountant and management access only.
                        </p>
                    </div>
                    <form className="space-y-4" onSubmit={onSubmit}>
                        <div>
                            <Label
                                htmlFor="email"
                                className="label-caps !text-[10px]"
                            >
                                Email
                            </Label>
                            <Input
                                id="email"
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="mt-1 rounded-none h-10"
                                data-testid="login-email"
                            />
                        </div>
                        <div>
                            <Label
                                htmlFor="password"
                                className="label-caps !text-[10px]"
                            >
                                Password
                            </Label>
                            <Input
                                id="password"
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="mt-1 rounded-none h-10"
                                data-testid="login-password"
                            />
                        </div>
                        <Button
                            type="submit"
                            disabled={submitting}
                            className="w-full rounded-none h-10 mt-2"
                            style={{ background: "#a12a65", color: "white" }}
                            data-testid="login-submit"
                        >
                            {submitting ? "Signing in…" : "Sign in"}
                        </Button>
                    </form>
                    <div className="mt-6 pt-4 border-t border-[#e4e4e7] text-xs text-zinc-500">
                        Admin seed:{" "}
                        <span className="font-mono">admin@allcrane.com</span>
                    </div>
                </div>
                <div className="mt-6 text-center text-[10px] uppercase tracking-[0.24em] text-zinc-500">
                    All Crane Sales · Demo data
                </div>
                <div className="mt-3 text-center text-[11px] text-zinc-500">
                    <a href="/privacy" className="hover:text-zinc-200 transition-colors">Privacy</a>
                    <span className="mx-2 text-zinc-700">·</span>
                    <a href="/terms" className="hover:text-zinc-200 transition-colors">Terms</a>
                </div>
            </div>
        </div>
    );
}
